import { withAntePostBasedMarketTemplateModelSelectors } from '@swf/sports/models/market-templates/antePostBased';

import { defaultState } from './defaultState';

export const selectors = withAntePostBasedMarketTemplateModelSelectors(defaultState, (slice) => ({
  hasPreloaded: () => slice((state) => state.hasPreloaded),
  isLoading: () => slice((state) => state.isLoading),
  hasErrored: () => slice((state) => state.errorCode),
  templates: () => slice((state) => state.templates),
  hasAntePostMarketClosed: () => slice((state) => state.hasAntePostMarketClosed),
  firstEventType: () =>
    slice((state) => {
      const eventTypes = Object.values(state.eventTypes);
      return eventTypes[0];
    }),
  firstEvent: () =>
    slice((state) => {
      const event = Object.values(state.events);
      return event[0];
    }),
  firstMarket: () =>
    slice((state) => {
      const market = Object.values(state.markets);
      return market[0];
    })
}));
